import { render } from "./Registro.vue?vue&type=template&id=7e2ebdf2&scoped=true"
import script from "./Registro.vue?vue&type=script&lang=js"
export * from "./Registro.vue?vue&type=script&lang=js"

import "./Registro.vue?vue&type=style&index=0&id=7e2ebdf2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7e2ebdf2"

export default script